// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"86":"38084126","297":"a2d8c4d4","643":"851a9e5b","787":"d8d8d144"}[chunkId] + ".chunk.js";
};